import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

import { InfoCardVariant } from './types';

export const InfoCardStyled = styled('div')<{ variant?: InfoCardVariant }>(
  ({ theme, variant }) => ({
    borderRadius: 12,
    transition: 'background-color 0.2s ease',
    border: `1px solid ${Colors.gray200}`,

    '.info-card-header': {
      backgroundColor: variant === 'gray' ? Colors.gray100 : Colors.blue50,
      padding: 12,
      borderRadius: '12px 12px 0 0',
      width: '100%',
      transition: theme.transitions.create(['color', 'background-color']),

      '&:hover': {
        color: Colors.hover,
        backgroundColor: variant === 'gray' ? Colors.gray200 : Colors.blue100,
      },
      '&:active': {
        backgroundColor: variant === 'gray' ? Colors.gray300 : Colors.blue200,
      },

      '.info-card-icons': {
        marginLeft: 'auto',
      },
    },

    '.info-card-field-label': {
      color: Colors.gray700,
    },
  })
);

export const InfoCardFieldsStyled = styled('div', {
  shouldForwardProp: (prop: string) => prop !== 'columnCount',
})<{ columnCount?: number }>(({ columnCount = 2 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
  gap: 12,
  padding: 12,
}));
